export default "__VITE_ASSET__BOUoDy$X__"